<template>
    <SelectDropDown
            :id="id"
            :name="name"
            :label="label"
            @selection-change="countrySelected"
            :options="countries"
            :defaultSelected="defaultSelected ? {id: defaultSelected.iso} : countries[0]"
    />
</template>

<script>
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import sharedService from "@/services/shared.service";

    export default {
        name: "CountryDropdown",
        components: {SelectDropDown},
        props: {
            id: String,
            name: String,
            label: String,
            defaultSelected: Object
        },
        created() {
            sharedService.fetchCountries()
                .then(({data}) => {
                    this.countries.push({
                        id: 'none',
                        name: '(всички)'
                    });
                    data.map((country) => {
                        const tempCountry = country;
                        tempCountry.id = country.iso;
                        return tempCountry;
                    });
                    data.forEach(country => this.countries.push(country));
                });
        },
        data() {
            return {
                countries: []
            }
        },
        methods: {
            countrySelected(value) {
                this.$emit('selection-change', {
                    id: value.dropDownId,
                    isDropdown: true,
                    name: value.name,
                    label: value.label,
                    currentValueId: value.currentValue ? value.currentValue.id === 'none' ? '' : value.currentValue.id : '',
                    currentValue: value.currentValue ? value.currentValue.id === 'none' ? '' : value.currentValue.name : '',
                    oldValue: value.oldValue
                });
            }
        }
    }
</script>

<style scoped>

</style>
